import React from "react";
import Section from "../../../components/layout/marketing/Section";
import Chip from "../../../components/common/chip";
import { Button } from "../../../components/common/button";
import { AI_AGENT_FEATURES } from "../../../config/marketing/aiAgent";
import AIAgentFeatureRow from "../components/AIAgentFeatureRow";
import { assets } from "../../../assets/assets";
import { buildScheduleDemoUrl } from "../../../utils/url";

export default function AIAgentSection() {
    const handleScheduleDemo = () => {
        const url = buildScheduleDemoUrl();
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return (
        <Section className="bg-bg-page" id="eisha">
            <div className="grid items-center gap-16 md:grid-cols-2">
                {/* Left content */}
                <div className="flex md:block items-center flex-col">
                    <Chip>AI Agent</Chip>

                    <h2 className="mt-4 text-4xl font-semibold md:leading-tight tracking-tight text-text-primary md:text-5xl text-center md:text-left">
                        Meet <span className="bg-brand-gradient bg-clip-text text-transparent">Eisha</span>
                        <br />
                        <span className="text-text-primary">Your AI receptionist</span>
                    </h2>

                    <p className="mt-4 max-w-lg md:text-xl font-medium text-text-secondary">
                        Eisha is perfect for busy professionals and the unpredictable reality of clinical practice. She
                        transforms how you manage your day.
                    </p>

                    <ul className="mt-6 space-y-4">
                        {AI_AGENT_FEATURES.map((feature) => (
                            <li key={feature.id} className="flex gap-3">
                                <div className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 p-2">
                                    <feature.icon className="h-12 w-12 text-primary" />
                                </div>

                                <p className="md:text-lg text-text-secondary">{feature.description}</p>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-8">
                        <Button variant="primaryGlow" size="md" onClick={handleScheduleDemo}>
                            Schedule a Demo
                        </Button>
                    </div>
                </div>

                {/* Right card */}
                <div className="w-full h-full">
                    <div className="w-full rounded-2xl bg-[linear-gradient(90deg,#B9FBEA_0%,#6FD3D6_100%)] p-6 shadow-xl py-24">
                        {/* Avatar */}
                        <div className="flex justify-center">
                            <img
                                src={assets.eisha_avatar}
                                alt="Eisha AI"
                                className="h-48 w-48 rounded-full bg-white shadow"
                            />
                        </div>

                        {/* Feature list */}
                        <div className="mt-6 space-y-6 px-2 md:px-6">
                            {AI_AGENT_FEATURES.map((feature) => (
                                <AIAgentFeatureRow key={feature.id} feature={feature} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    );
}
